import { render, staticRenderFns } from "./FavouriteTracksList.vue?vue&type=template&id=16320871"
import script from "./FavouriteTracksList.vue?vue&type=script&lang=js"
export * from "./FavouriteTracksList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports